import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthShell, Field, FormError, SubmitButton } from "@/components/AuthShell";
import { Input } from "@/components/ui";
import { useAuth } from "@/lib/auth";
import { apiError, endpoints } from "@/lib/api";
import { ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const { user, setUser, loading } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [err, setErr] = React.useState("");
  const [busy, setBusy] = React.useState(false);

  React.useEffect(() => {
    if (!loading && user?.role === "admin") nav("/admin", { replace: true });
  }, [user, loading, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const r = await endpoints.adminLogin(email, password);
      setUser(r.data);
      nav("/admin", { replace: true });
    } catch (ex) { setErr(apiError(ex)); } finally { setBusy(false); }
  };

  return (
    <AuthShell testid="admin-login-page" eyebrow={<span className="inline-flex items-center gap-1.5"><ShieldCheck size={11} /> Restricted</span>}
      title={<>Admin <span className="italic text-gold">Access</span></>}
      subtitle="Administrator sign-in for user, usage and API key management."
      footer={<Link to="/login" className="text-gold hover:underline" data-testid="admin-login-to-login">← Back to user sign in</Link>}>
      <form onSubmit={submit} data-testid="admin-login-form">
        <FormError msg={err} />
        <Field label="Admin email"><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" autoComplete="email" /></Field>
        <Field label="Password"><Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" autoComplete="current-password" /></Field>
        <SubmitButton loading={busy} testid="admin-login-submit">Sign in as admin</SubmitButton>
      </form>
    </AuthShell>
  );
}
